import { Link } from "react-router-dom";

export default function LegalLayout({ title, children, testId }) {
  return (
    <div className="min-h-screen bg-teamie-bg" data-testid={testId}>
      <header className="border-b border-teamie-border bg-teamie-bg/90 backdrop-blur-sm">
        <div className="max-w-3xl mx-auto px-6 sm:px-8 py-6 flex items-center justify-between gap-6">
          <Link
            to="/"
            className="font-heading text-2xl font-bold text-teamie-text hover:text-teamie-accent transition-colors duration-300"
          >
            teamie.
          </Link>
          <nav className="flex gap-6 text-sm font-mono tracking-wide uppercase">
            <Link to="/privacy" className="text-teamie-text-secondary hover:text-teamie-accent">
              Privacy
            </Link>
            <Link to="/terms" className="text-teamie-text-secondary hover:text-teamie-accent">
              Terms
            </Link>
          </nav>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 sm:px-8 py-16">
        <h1 className="font-heading text-3xl sm:text-4xl text-teamie-text mb-2">{title}</h1>
        <p className="font-mono text-[11px] tracking-wide text-teamie-text-secondary/70 mb-12">
          Last updated: June 10, 2026
        </p>
        <div className="legal-content space-y-8 font-body text-teamie-text-secondary leading-relaxed">
          {children}
        </div>
      </main>

      <footer className="border-t border-teamie-border py-10 px-6 text-center">
        <p className="font-mono text-[11px] text-teamie-text-secondary/60">
          &copy; {new Date().getFullYear()} teamie.{" "}
          <Link to="/" className="hover:text-teamie-accent">
            Back to home
          </Link>
        </p>
      </footer>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-heading text-xl text-teamie-text mb-3">{title}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}

export { Section };
